module.exports = __webpack_public_path__ + "static/nasa1-83473150461baabebe2fc2d742c944f5.gif";